import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

export default function Error404() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Gandhi Mandela Foundation</title>
        <meta
          name="description"
          content="The page you are looking for could not be found."
        />
      </Helmet>

      <Header />
      <main>
        <section className="page-header">
          <div className="container">
            <div className="breadcrumb">
              <a href="/">Home</a>
              <span>/</span>
              <span>Page Not Found</span>
            </div>
            <h1>Page Not Found</h1>
          </div>
        </section>

        <section className="section">
          <div className="container" style={{ textAlign: "center" }}>
            <p
              style={{
                fontSize: 72,
                fontWeight: 700,
                color: "var(--gold)",
                lineHeight: 1,
                marginBottom: 20,
              }}
            >
              404
            </p>
            <h2 style={{ fontSize: 30, marginBottom: 12 }}>
              Sorry, this page does not exist.
            </h2>
            <p style={{ color: "var(--muted)", marginBottom: 28 }}>
              The page you are looking for may have been moved or removed.
            </p>
            <a className="btn btn-primary" href="/">
              Return to Home
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
